import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { IAllCardsFiltersFormFields } from '@/features/cards/store/types/agent-card.types';
import { ISearch, ISearchField } from '@/ui-kit/table-filters/filters.type';

export function mapAllCardsSearch(value) {
  return { [value.key]: value.value };
}

export function useAllCardsSearchField(methods: UseFormReturn<IAllCardsFiltersFormFields>, onChange): ISearchField {
  const { t } = useTranslation();

  const handleSearchChange = useCallback(
    (value: ISearch) => {
      const currentValue = methods.getValues('search');
      const newValue = Object.keys(value).reduce<ISearch>((prev, current) => {
        return { ...prev, [current]: value[current] === null ? currentValue[current] : value[current] };
      }, {} as ISearch);

      methods.setValue('search', newValue);
      if (value.key !== null && value.value !== null) {
        onChange();
      }
    },
    [onChange, methods],
  );

  const searchOptions: TOption[] = [
    { label: t('pages.currentProfiles.cards.card.cardId'), value: 'cardId' },
    { label: t('pages.currentProfiles.cards.card.publicToken'), value: 'publicToken' },
    { label: t('pages.currentProfiles.cards.card.embossedName'), value: 'embossedName' },
  ];
  const searchValue = methods.watch('search');

  return { value: searchValue, handleChange: handleSearchChange, options: searchOptions };
}
